/* eslint-disable jsx-a11y/anchor-is-valid */
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.min.js";
import 'bootstrap-icons/font/bootstrap-icons.css';

import React, { useContext, useEffect, useState, useRef } from 'react';
import mobiscroll from '@mobiscroll/react'
import * as m5 from '@mobiscroll/react5'
import '@mobiscroll/react/dist/css/mobiscroll.min.css'
import '@mobiscroll/react5/dist/css/mobiscroll.min.css'
import { db } from './index'
import { AppContext } from './Launcher'
import Auth from './Auth'
import Config, { AppPopover, displayColsOption, RateConfirmPopover, UpgradeConfirmPopover, UpgradePage } from './components/Config'
import Transaction from './components/Transaction'
import Record from './components/Record'
import Stock from './components/Stock'
import History from './components/History'
import Archive from './components/Archive';
import './App.css';
import { getTimestamp, numberWithCommas, styleNumber, useStockInfoPZ, usePrevious, useDailyInfo, callTpexPZ, toTWDateStringOnlyNum } from './Helper';
import dealersOptions from './dataset/dealers.json'
import stocksOptions from './dataset/stocks.json'
import { version } from '../package.json'

const ls_ShowRateTime = 'ShowRateTime'
const ls_UpgradeHintDate = 'UpgradeHintDate' //每日升級提醒 最後顯示日期
const upgradeHintText = '為了提供更好更完整的記帳功能\n請升級使用完整版的記帳本'
const refreshInterval = 30

const total = {
  revenue: 0,
  stock: 0
}

const dealerName = (dealer) => {
  return dealer.name ? dealer.name : dealersOptions.filter(d => d.id === dealer.id)[0].name
}

const Profile = React.memo(({ p, data, theme, dealer, setDealer }) => {
  const { dealers } = p
  const dealerOpt = [{ value: '', text: '所有帳戶' }, ...dealers.map(o => ({ value: o.id, text: dealerName(o) }))]
  let dealerText = '所有帳戶'
  if (dealerOpt.filter(d => d.value === dealer).length > 0) {
    dealerText = dealerOpt.filter(d => d.value === dealer)[0].text
  } else {
    setDealer('')
  }
  const dealerSelect = useRef(null)
  const [showInfo, setShowInfo] = useState(false)
  const total = data.totalMktCap ? numberWithCommas(data.totalMktCap) : '0'
  const expense = data.totalExpense ? numberWithCommas(data.totalExpense) : '0'
  const totalProfit = data.totalProfit ? data.totalProfit : 0
  const income = data.totalIncome ? numberWithCommas(data.totalIncome - totalProfit) : '0'
  const cost = data.totalCost ? numberWithCommas(data.totalCost) : '0'
  const profit = data.totalProfit ? numberWithCommas(data.totalProfit) : '0'
  const spIncome = styleNumber(data.totalRevenue)
  const spToday = styleNumber(data.totalToday)
  const r = 40
  const circumference = r * 2 * Math.PI
  const progress = data.totalMktCap ? data.totalMktCap / p.target : 0

  const openInfo = () => {
    setShowInfo(true)
  }

  const showDealers = () => {
    dealerSelect.current.instance.show()
  }

  const changeDealer = (e, inst) => {
    setDealer(inst.getVal())
  }

  const { appContext } = useContext(AppContext)
  const blinkCls = appContext.apiCalling ? 'blink-el' : ''

  return (
    <div className="row m-0 pt-3 w-100" style={{ minHeight: '25%', fontSize: '1.125rem' }}>
      <div className="col-4 px-0 pr-0 text-center">
        <svg
          className="progress-ring"
          width="100"
          height="100">
          <circle
            className="progress-ring__circle"
            stroke="#dc3545"
            strokeWidth="4"
            strokeDasharray={circumference + ' ' + circumference}
            strokeDashoffset={circumference - progress * circumference}
            fill="#efeff425"
            r={r}
            cx="52"
            cy="50" />
        </svg>
        <div style={{ marginTop: -88 }}>
          <img style={{ zIndex: 1010 }} src={p.photoUrl || '/img/avatar.svg'}
            className="rounded-circle bg-dark" width="72" height="72" alt="..." />
          <div className="mt-2" style={{ fontSize: '1rem' }}>{p.name || '匿名'}</div>
        </div>
      </div>
      <div className="col-8 pl-2 pr-0">
        <div>
          {dealers.length > 1 ?
            <>
              <button className={'mr-3 px-1 btn btn-sm btn-' + theme}
                style={{ height: '1.5rem', padding: 0, verticalAlign: 'baseline' }}
                onClick={showDealers}>{dealerText}</button>
              <small>累積損益</small>
              <mobiscroll.Select
                ref={dealerSelect}
                themeVariant={theme}
                display="bottom" setText="確定"
                value={dealer}
                onSet={changeDealer}
                showInput={false}
                showOnFocus={false}
                data={dealerOpt}>
              </mobiscroll.Select>
            </>
            : <small>累積損益</small>}
          <i className="bi bi-info-circle align-text-top" style={{ fontSize: '0.875rem', marginLeft: 6 }} onClick={openInfo}></i>
        </div>
        <div className={'h3 text-center mb-0 ' + spIncome.color}>
          {spIncome.number}
        </div>
        <div className="align-middle">
          <small className="px-1">當日損益</small>
          <span className={'align-middle ml-3 ' + spToday.color + ' ' + blinkCls}>{spToday.number}</span>
        </div>
        <div className="align-middle">
          <small className="px-1">庫存市值</small>
          <span className="align-middle ml-3">{total}</span>
        </div>
      </div>
      <m5.Popup
        isOpen={showInfo}
        themeVariant={theme}
        buttons={[{
          text: '確認',
          handler: () => { setShowInfo(false) }
        }]}
      >
        <div className="mbsc-align-center mbsc-padding">
          <h4>統計資訊</h4>
          <div className="d-flex justify-content-between">
            <span>買入支出：</span><span>{expense}</span>
          </div>
          <div className="d-flex justify-content-between">
            <span>交易成本：</span><span>{cost}</span>
          </div>
          <div className="d-flex justify-content-between">
            <span>賣出收入：</span><span>{income}</span>
          </div>
          <div className="d-flex justify-content-between">
            <span>股息收入：</span><span>{profit}</span>
          </div>
          <div className="d-flex justify-content-between">
            <span>累積報酬率：</span><span>{(data.totalRevenue / data.totalExpense * 100).toFixed(2)}%</span>
          </div>
          <hr />
          <div className="d-flex justify-content-between">
            <span>庫存檔數：</span><span>{data.stockNum}</span>
          </div>
          <div className="d-flex justify-content-between">
            <span>已結算檔數：</span><span>{data.soldNum}</span>
          </div>
        </div>
      </m5.Popup>
    </div>
  )
})

const Main = ({ active, data, isloading, handler, stockPZ }) => {

  const { appContext } = useContext(AppContext)
  const { price, cols, theme, revenue } = appContext
  const { setTotalData } = handler
  const colsIdx = Math.max(displayColsOption.findIndex(c => c.value === cols), 0)
  const colsArray = displayColsOption[colsIdx].cols

  const props = {
    theme,
    data,
    handler
  }

  let txt = ''
  let bg = ''
  if (theme === 'dark') {
    txt = 'text-light'
    bg = 'bg-black'
  }

  useEffect(() => {
    if (data.length === 0 && isloading !== true) {
      setTotalData(
        {
          totalRevenue: 0, totalMktCap: 0, totalToday: 0,
          totalExpense: 0, totalIncome: 0, totalCost: 0,
          soldNum: 0, stockNum: 0
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])


  return (
    <div className={'App-main ' + bg}>
      {
        isloading ?
          <div className="d-flex justify-content-center mt-4">
            <div className={'spinner-border ' + txt} role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div> : data.length === 0 ?
            <>
              <div className={'d-flex justify-content-center mt-4 ' + txt}>
                請點擊『＋』新增第一筆交易紀錄吧！
              </div>
              <div className="d-flex justify-content-end my-4">
                <button type="button" className="btn btn-secondary rounded-pill m-2 py-2"
                  onClick={handler.openArchive}>
                  已封存
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </> :
            {
              stock: <Stock {...props} stockPZ={stockPZ} cols={colsArray} priceConfig={price} revenueConfig={revenue} />,
              record: <Record {...props} />
            }[active]
      }
    </div>
  )
}

const ConfigBtn = ({ onClick }) => {
  return (
    <div className="App-config" style={{ fontSize: '1.75rem' }}
      onClick={onClick}>
      <i className="bi bi-gear"></i>
    </div>
  )
}

const AddBtn = ({ onClick }) => {
  return (
    <button id="addBtn" className="btn rounded-circle bg-danger m-2 p-0"
      style={{ width: '4rem', height: '4rem', fontSize: '3.5rem' }}
      onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg"
        style={{ marginTop: '-2rem' }}
        width="4rem" height="4rem" fill="currentColor" className="bi bi-plus text-white" viewBox="0 0 16 16">
        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
      </svg>
    </button>
  )
}

const Btn = ({ theme, id, icon, text, isActive, onClick, size }) => {

  const click = () => {
    onClick(id)
  }

  let cls = 'text-decoration-none'
  if (theme === 'dark') {
    if (isActive) {
      cls += ' text-white'
    } else {
      cls += ' text-white-50'
    }
  } else {
    if (isActive) {
      cls += ' text-primary'
    } else {
      cls += ' text-dark'
    }
  }

  const iconStyle = size ? {
    fontSize: size + 'rem'
  } : {
    fontSize: '1.5rem'
  }

  const iconContainerStyle = size ? {
    height: '1.875rem',
    paddingTop: ((1.5 - size) / 2) + 'rem'
  } : { height: '1.875rem' }

  return (
    <a className={cls} href="#" onClick={click}>
      <div className="text-center mb-1">
        <div style={iconContainerStyle}>
          <i className={icon} style={iconStyle}></i>
        </div>
        <div style={{ fontSize: '0.875rem' }}>{text}</div>
      </div>
    </a>
  )
}

const Modal = ({ theme, renderContent }) => {
  let bg = '#efeff4'
  if (theme === 'dark') {
    bg = '#000000'
  }
  return (
    <div className="App-modal" style={{ background: bg }}>
      {renderContent()}
    </div>
  )
}

const stockInfoParam = (data) => {
  let params = ''
  let q = []
  data.forEach((d) => {
    if (q.filter(s => s.id === d.id).length === 0) {
      let mkt = d.mkt
      const idx = stocksOptions.findIndex(s => s.id === d.id)
      if (idx > -1) {
        const stock = stocksOptions[idx]
        mkt = stock.type === '上市' ? 'tse' : stock.type === '上櫃' ? 'otc' : 'tpex'
      }
      q.push({ id: d.id, mkt })
    }
  })
  q.forEach(s => {
    if (s.mkt !== 'tpex') {
      if (params) {
        params += '|'
      }
      params += s.mkt + '_' + s.id + '.tw'
    }
  })
  return params
}

const stockDUrl = (data) => {
  let urls = []
  let q = []
  const di = JSON.parse(localStorage.getItem('DailyInfo'))
  if (di) {
    data.forEach((d) => {
      if (q.filter(s => s.id === d.id).length === 0 && di.s.filter(s => s.id === d.id && s.z === undefined).length > 0) {
        q.push({ id: d.id, mkt: d.mkt })
      }
    })
    q.forEach(s => {
      let u = 'https://www.twse.com.tw/exchangeReport/STOCK_DAY?stockNo=' + s.id
      if (s.mkt === 'otc') { //上櫃
        u = 'https://www.tpex.org.tw/web/stock/aftertrading/daily_trading_info/st43_result.php?stkno=' + s.id
      }
      if (!window.Stockbook) { //本機測試
        u = 'https://cors-anywhere.herokuapp.com/' + u
      }
      urls.push(u)
    })
  }
  return urls
}

const App = ({ user }) => {

  const [loading, setLoading] = useState(true)
  const [activePage, setActivePage] = useState('stock')
  const [rawData, setRawData] = useState([])
  const [appData, setAppData] = useState([])
  const [mainData, setMainData] = useState([])
  const [stockPZ, setParams] = useStockInfoPZ()
  const prevStockPZ = usePrevious(stockPZ)
  const [stockD, setUrls] = useDailyInfo()
  const [totalData, setTotalData] = useState(total)
  const [config, setConfig] = useState(null)
  const [transaction, setTransaction] = useState(null) //正在編輯之交易
  const [history, setHistory] = useState(null)
  const [modal, setModal] = useState(null)
  const [pop, setPop] = useState(null)
  const [dealer, setDealer] = useState('')
  const [confirm, setConfirm] = useState(null)
  const [upgradeHint, setUpgradeHint] = useState(null)
  const [searching, setSearching] = useState(false)
  const [searchContext, setSearchContext] = useState('')
  const searchHandelr = {
    searching, setSearching,
    searchContext, setSearchContext
  }

  const { appContext, dispatchAppContext } = useContext(AppContext)
  const { theme, multiSync } = appContext
  const bg = theme === 'dark' ? 'bg-dark' : 'bg-white'

  useEffect(() => {
    window.onhashchange = () => {
      const modal = document.location.hash ? document.location.hash.replace('#', '') : null
      if (modal === 'search') {
        return
      } else {
        setSearching(false)
      }
      setModal(modal)
      if (modal === null) {
        if (history) {
          setHistory(null)
        }
        if (transaction) {
          setTransaction(null)
        }
        setSearchContext('') //回首頁清除搜尋內容

      } else if (modal === 'history') {
        if (transaction) {
          setTransaction(null)
          setSearchContext('') //清除搜尋內容
        }
      }
    }
  }, [history, transaction])

  useEffect(() => {
    if (transaction) {
      openModal('edit')
    }
  }, [transaction])

  useEffect(() => {
    if (history) {
      openModal('history')
    }
  }, [history])

  useEffect(() => {
    //get userInfo
    if (user !== null) {
      let uid = user.id
      const docRef = db.collection('users').doc(uid)
      docRef.get().then((doc) => {
        let isVIP = ''
        const lastTime = parseInt(localStorage.getItem('syncTime') ?? "1748736000") //讀取同步時間 限制由2025年6月1日開始
        if (doc.exists) {
          const data = doc.data()
          dispatchAppContext({ type: "SET_VIP", vip: data.vip }) //設定VIP資訊
          isVIP = data.vip
          if (data.im) //匿名者匯入
            uid = data.im
          setConfig(data)
          //每日第一次開啟app 提醒升級完整版
          if (window.Stockbook) {
            const today = toTWDateStringOnlyNum(new Date())
            if (localStorage.getItem(ls_UpgradeHintDate) !== today) {
              localStorage.setItem(ls_UpgradeHintDate, today)
              setUpgradeHint(upgradeHintText)
            }
          }
        } else {
          setConfig({
            ...user,
            target: 5000000,
            dealers: []
          })
          openModal('config')
        }
        //開啟app時 改成cache first 2021.06.22 觀察是否可降低讀取數 / 2021.12.17增加VIP可同步
        if (isVIP && multiSync) { //VIP啟用同步機制
          syncAppData(uid, lastTime) //先同步資料再讀取快取
        } else {
          getAppData(uid, 'cache')
        }
      }).catch((error) => {
        console.log("Error getting document:", error);
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  const syncAppData = (user, lastTime) => {
    setLoading(true)
    db.collection("transactions")
      .where("user", "==", user)
      .where("ut", ">=", lastTime)
      .orderBy("ut", "desc")
      .get({ source: 'server' })
      .then((querySnapshot) => {
        localStorage.setItem("syncTime", getTimestamp()) //更新同步時間
        setLoading(false)
        getAppData(user, 'cache') //讀取快取資料
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
        setLoading(false)
        getAppData(user, 'cache') //讀取快取資料
      });
  }

  const getAppData = (user, source) => {
    setLoading(true)
    db.collection("transactions").where("user", "==", user)
      .orderBy("date", "desc")
      .get({ source })
      .then((querySnapshot) => {
        if (!querySnapshot.empty || source === 'default') {
          let data = []
          querySnapshot.forEach((doc) => {
            const docData = doc.data()
            if (!docData.delete) {
              data.push({ _id: doc.id, ...docData })
            }
          })
          setRawData(data)
          setAppData(data.filter(d => d.archive !== 1))
          if (dealer) {
            setMainData(data.filter(d => (d.dealer.id === dealer)))
          } else {
            setMainData(data)
          }
          setLoading(false)
          if (source === 'default') {
            localStorage.setItem("syncTime", getTimestamp()) //更新同步時間
          }
        } else { //沒有資料
          setTotalData(total)
          //首次載入app
          getAppData(user, 'default')
        }
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  }

  useEffect(() => {
    if (appData.length > 0) {
      setParams(stockInfoParam(appData))
      if (appData.some(d => d.mkt === 'tpex')) { //呼叫興櫃價格
        callTpexPZ()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appData])

  useEffect(() => {
    if (appData.length > 0) {
      if (JSON.stringify(stockPZ) !== JSON.stringify(prevStockPZ)) { //收盤後無價格異動則不自動呼叫
        const delayFetchId = setTimeout(() => {
          const str = stockInfoParam(appData) + '&t=' + getTimestamp()
          setParams(str)
          if (appData.some(d => d.mkt === 'tpex')) { //呼叫興櫃價格
            callTpexPZ()
          }
        }, refreshInterval * 1000)

        return () => {
          clearTimeout(delayFetchId)
        }
      }

      //需要觸發補值
      if (localStorage.getItem('DailyInfo')) {
        const di = JSON.parse(localStorage.getItem('DailyInfo'))
        if (di && di.s.filter(s => s.z === undefined).length > 0) {
          setUrls(stockDUrl(appData))
        }
      }

    }
    //用來觸發連續更新
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockPZ])

  useEffect(() => {
    if (appData.length > 0 && localStorage.getItem('DailyInfo')) {
      const di = JSON.parse(localStorage.getItem('DailyInfo'))
      if (di && di.s.filter(s => s.z === undefined).length > 0) {
        setUrls(stockDUrl(appData))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockD])

  useEffect(() => {
    if (dealer) {
      setMainData(appData.filter(d => (d.dealer.id === dealer)))
    } else {
      setMainData(appData)
    }
  }, [appData, dealer])

  const closeModal = (force) => {
    if (history && transaction) {
      setTransaction(transaction)
    } else {
      setModal(null)

      if (history) {
        setHistory(null)
      }
      if (transaction) {
        setTransaction(null)
      }
    }

    if (force) {
      window.history.back()
    } else {
      if (modal === 'config'
        && (config === null || config.name === null || config.dealers.length === 0)) {
        setPop('尚未完成設定')
      } else {
        window.history.back()
      }
    }
  }

  const openModal = (id) => {
    setModal(id)
    window.location.hash = id
  }

  const setMemoList = (memoList) => {
    const currConfig = { ...config, version: 'Lite-' + version, memoList }
    setConfig(currConfig)
    db.collection('users').doc(currConfig.id).set(currConfig)
      .then(() => {
        console.log("Document successfully written!");
      }).catch((error) => {
        console.error("Error writing document: ", error);
      });
  }

  const modalContent = () => (
    <>
      {
        {
          config: <Config config={config} title="設定" onSet={setConfig} onClose={closeModal} setAppLoading={setLoading} afterSave={getAppData} />,
          edit: <Transaction theme={theme} user={config.im || config.id} defDealer={dealer} dealers={config.dealers} transaction={transaction} afterSave={getAppData} onClose={closeModal} creditData={mainData.filter(d => d.credit)} {...searchHandelr} />,
          history: <History theme={theme} title="個股操作資料" user={config.im || config.id}  {...history}
            transactions={mainData.filter(d => history && d.id === history.stockNo)} setTransaction={setTransaction}
            afterArchive={getAppData} onClose={closeModal} memoList={config.memoList || []} setMemoList={setMemoList} />,
          archive: <Archive theme={theme} title="封存紀錄" transactions={rawData.filter(d => d.archive === 1)} onClose={closeModal} setTransaction={setTransaction} {...searchHandelr} />,
          upgrade: <UpgradePage theme={theme} onClose={closeModal} userId={config.im || config.id} isAnonymous={config.isAnonymous} />
        }[modal]
      }
    </>
  )

  const goRate = () => {
    if (window.Stockbook && window.Stockbook.rateApp) {
      window.Stockbook.rateApp() //顯示
    }
    localStorage.setItem(ls_ShowRateTime, getTimestamp() + 49 * 24 * 60 * 60) //2個月後再顯示
    setConfirm(null)
    openModal('edit')
  }

  const cancelRate = () => {
    localStorage.setItem(ls_ShowRateTime, getTimestamp())
    setConfirm(null)
    openModal('edit')
  }

  const goUpgrade = () => {
    setUpgradeHint(null)
    openModal('upgrade')
  }

  const addTransaction = () => {
    if (config.dealers.length === 0) {
      openModal('config')
    } else {
      setTransaction(null)
      let ed = true
      // if (!appContext.apiCalling) {
      //   //觸發評價提示
      //   const sr = localStorage.getItem(ls_ShowRateTime)
      //   if ((sr && getTimestamp() - parseInt(sr) > 7 * 24 * 60 * 60) || sr === null) {
      //     if (config) {
      //       if (getTimestamp() - config.ct > 7 * 24 * 60 * 60 && appData.length > 50) { //使用超過7天且紀錄超過50筆
      //         ed = false
      //         setConfirm('歡迎股票記帳本！\n希望在台股投資上有幫助到您\n用5星支持給開發者鼓勵吧！')
      //       }
      //     }
      //   }
      // }
      if (ed) {
        openModal('edit')
      }
    }
  }

  const onClickNavBtn = (page) => {
    setActivePage(page)
  }

  const updatePZ = () => {
    const str = stockInfoParam(appData) + '&t=' + getTimestamp()
    setParams(str)
  }

  const openArchive = () => {
    openModal('archive')
  }

  const handler = {
    setHistory,
    setTransaction,
    setTotalData,
    updatePZ,
    openArchive,
  }

  return (
    <>
      {
        user === null ? <Auth theme={theme} /> :
          <div className="App-container">
            <AppPopover text={pop} onSet={() => { setPop(null) }} />
            <RateConfirmPopover text={confirm} onCancel={cancelRate} onConfirm={goRate} />
            <UpgradeConfirmPopover text={upgradeHint} onCancel={() => { setUpgradeHint(null) }} onConfirm={goUpgrade} />
            <ConfigBtn onClick={() => { openModal('config') }} />
            {config && <Profile p={config} data={totalData} theme={theme} dealer={dealer} setDealer={setDealer} />}
            <Main active={activePage} data={mainData} handler={handler} isloading={loading} stockPZ={stockPZ} />
            {
              modal && <Modal theme={theme} renderContent={modalContent} />//<Modal id={modal} onClose={() => (setModal(null))} />
            }
            <div className={'Add-btn rounded-circle fixed-bottom mx-auto ' + bg} style={{ width: '5rem', height: '5rem' }}>
              <AddBtn onClick={addTransaction} />
            </div>
            <div className={'fixed-bottom px-0 w-100 ' + bg}>
              <div className="d-flex justify-content-around w-100">
                <Btn theme={theme} id="stock" icon="bi bi-list-ul" text="持股" onClick={onClickNavBtn} isActive={activePage === 'stock'} />
                <span>x</span>
                <Btn theme={theme} id="record" icon="bi bi-calendar" text="記錄" size={1.3} onClick={onClickNavBtn} isActive={activePage === 'record'} />
              </div>
            </div>
          </div>
      }
    </>
  )
}

export default App;
